var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "interactive-form-action-button-block"
  }, [_c('div', {
    staticClass: "interactive-form-action-button-block__button",
    class: {
      'interactive-form-action-button-block__button--disabled': _vm.disabled
    },
    style: _vm.disabled ? 'pointer-events: none; opacity: 0.6;' : '',
    attrs: {
      "aria-disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("button-content")], 2), _vm.withPressEnter ? _c('span', {
    staticClass: "interactive-form-action-button-block__press-enter"
  }, [_vm._v(" Press "), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Enter ↵")])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }